module.exports = __webpack_public_path__ + "media/images/emp/sort_desc_disabled-bda51e15154a18257b4f955a222fd66f.png";